var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"IkeSidebar\">\n<div class=\"IkeSidebar-titleBlock\">\n<h3 class=\"IkeSidebar-titleText\">{{ sidebarTitle }}</h3>\n</div>\n<div class=\"IkeSidebar-content\" ng-transclude></div>\n</div>";
var id1="ike.sidebar.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/layout/sidebar/ike.sidebar.html
// module id = 466
// module chunks = 0